"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceType = exports.Permission = exports.DeviceStatus = exports.UserRole = void 0;
var UserRole;
(function (UserRole) {
    UserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
    UserRole["ADMIN"] = "ADMIN";
    UserRole["OFFICE_WORKER"] = "OFFICE_WORKER";
    UserRole["UNASSIGNED"] = "UNASSIGNED";
})(UserRole || (exports.UserRole = UserRole = {}));
var DeviceStatus;
(function (DeviceStatus) {
    DeviceStatus["ACTIVE"] = "ACTIVE";
    DeviceStatus["PENDING"] = "PENDING";
    DeviceStatus["REJECTED"] = "REJECTED";
})(DeviceStatus || (exports.DeviceStatus = DeviceStatus = {}));
var Permission;
(function (Permission) {
    Permission["READ"] = "READ";
    Permission["WRITE"] = "WRITE";
    Permission["DELETE"] = "DELETE";
    Permission["ADMIN"] = "ADMIN";
})(Permission || (exports.Permission = Permission = {}));
var ResourceType;
(function (ResourceType) {
    ResourceType["FILE"] = "FILE";
    ResourceType["FOLDER"] = "FOLDER";
    ResourceType["DEVICE"] = "DEVICE";
    ResourceType["USER"] = "USER";
    ResourceType["SYSTEM"] = "SYSTEM";
})(ResourceType || (exports.ResourceType = ResourceType = {}));
